import { aliasTimezoneResolver } from "./aliases.js";
import { isValidIanaTimezone, safeTimezone } from "./normalization.js";

/** Strict IANA timezone validation — rejects ambiguous abbreviations and invalid aliases */
export function validateTimezone(timeZone: string | null | undefined): boolean {
  const resolved = aliasTimezoneResolver(timeZone);
  if (!resolved.resolved) return false;
  return isValidIanaTimezone(resolved.resolved);
}

/** Normalise and validate with fallback — enterprise-safe default */
export function safeTimezoneFallback(
  timeZone: string | null | undefined,
  fallback = "UTC",
): string {
  const resolved = aliasTimezoneResolver(timeZone);
  if (resolved.resolved && isValidIanaTimezone(resolved.resolved)) {
    return resolved.resolved;
  }
  return safeTimezone(fallback, "UTC");
}
